export default () => {
    let element = document.getElementById('google-api-key');
    return element.value;
};
